<template>
  <div class="page-master" >
    <div v-if="'{}' != JSON.stringify(components) ">
      <jr-button @click="createKey" :components="components['CT0030000000091']" :loading="queryLoding"  :badge="badge" @badge-click="badgeClick" type="success" icon="el-icon-plus">生成KEY</jr-button>
      <br><jr-inputarea v-model="cpuId" :rows="6" :components="components['CT0030000000092']" :badge="badge" @badge-click="badgeClick"></jr-inputarea>          
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { initpage } from '@/api/pagetable'
import { getCpuIdByJrkey } from '@/api/keylicence'
import { Notification } from 'element-ui'
export default {
  name: 'KeyFactory',
  deactivated(){
    if(store.getters.closePageNames==this.$options.name){
        this.$destroy(this.$options.name)
    }
  },
  created() {
    this.initpage(this.$options.name)
  },
  data () {
    return {
      // 后台传递的组件对象
      components: {},
      // 表格对象的相关属性
      tablelist: {},      
      // 获取cpuId
      cpuId: '',
      // 查询按钮状态属性
      queryLoding: false      
    }
  },
  props: {
    badge: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    badgeClick(id,bv) {
      this.components[id]['controlRighttype'] = bv        
    },
    // 页面加载
    initpage(pageName) {
      initpage(pageName).then(res => {
        const code = res.status.code    
        if(code == 200){
          const components = res.data.pagetablelist
          components.forEach(item=> {
            this.$set(this.components, item.controlId, item)
          })
        }
      })
      .catch(error => {
        return Promise.reject('error')
      })   
    },
    // 查询按钮
    createKey() {
      this.queryLoding = true
      getCpuIdByJrkey(this.cpuId).then(res => {
        const code = res.status.code    
        if(code == 200){
          const cpuId = res.data.cpuId           
          this.cpuId = cpuId
        }
        this.queryLoding = false
      })
      .catch(error => {
        this.queryLoding = false
        return Promise.reject('error')
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/KeyFactory.vue